<template>
  <Dialog v-model="dialog" width="450" :showTitleDivider="showTitleDivider">
    <template v-if="title || $slots.title" slot="title">
      <slot name="title">
        <span class="_dialog-title">{{title}}</span>
      </slot>
    </template>

    <template v-if="text || $slots.content" slot="content">
        <section class="confirm-subtitle">
        <slot name="content">
          <div class="pt-2 pb-5">
            {{text}}
          </div>
        </slot>
      </section>
    </template>

    <template slot="actions">
      <div class="d-flex justify-end" style="gap: 8px">
        <Button
          outlined
          label="Cancelar"
          text-color="bt_color"
          textSize="0.80rem"
          @click="dialog = false"
        />

        <Button 
          :label="titleMsg" 
          textSize="0.80rem" 
          @click="() => {
            $emit('confirmDone')
            dialog = false
          }"
        />
      </div>
    </template>     
  </Dialog>
</template>

<script>
import Dialog from "./Dialog.vue"
import Button from './Button.vue'

export default {
  name: 'ConfirmDialog',
  components: {Dialog, Button},
  props: {
    value: {type: Boolean, required: true},
    title: {type: String},
    titleMsg: {type: String, default: 'Confirmar'},
    text: {type: String},
    showTitleDivider: {type: Boolean, default: true}
  },
  computed: {
    dialog: {
      get () { return this.value },
      set (v) { this.$emit('input', v)}
    }
  }
}
</script>

<style scoped>
.confirm-subtitle {
  font-size: 13.5px;
  font-weight: 400;
  color: #666D80;
  letter-spacing: 0.3px;
}
</style>